<ng-container *ngIf="fuseConfig.layout.style === 'vertical-layout-2'">
  <vertical-layout-2></vertical-layout-2>
</ng-container>
<ng-container>
  <fuse-sidebar [invisibleOverlay]="false" [lockedOpen]="true" name="intelyproCart" position="right">
    <app-cart-sidebar *ngIf="!!shoppingCartService.showCart.value"></app-cart-sidebar>
  </fuse-sidebar>
  <fuse-sidebar (openedChanged)="confirmSidebarClosed($event)" [invisibleOverlay]="false" [lockedOpen]="true" name="intelyproConfirmCart" position="right">
    <app-confirm-cart-sidebar *ngIf="!!shoppingCartService.totalCartInfo.value"></app-confirm-cart-sidebar>
  </fuse-sidebar>
  <fuse-sidebar [invisibleOverlay]="true" class="boost-approval-sidebar" name="boostApprovalQueue" position="left">
    <app-boost-approval-queue></app-boost-approval-queue>
  </fuse-sidebar>
</ng-container>
